import { Data } from '@/modules/shared/models/data'
import { BasicUserResourceModel } from '@/modules/user/models/user-resource.model'

export enum ExportExcelStatus {
  PENDING = 'pending',
  FINISHED = 'finished'
}

export interface ExportCheckStatusResourceModel {
  id: number
  status: ExportExcelStatus
  url?: string
}

export interface ExportExcelResourceModel {
  id: number
  name: string
  status: ExportExcelStatus
  path: string
  created_at: string
  updated_at: string
  user: BasicUserResourceModel
}

export interface ExportExcelResourceWithModel {
  statuses: { [key in ExportExcelStatus]: string }
}

export type ExportExcelResourceType = Data<ExportExcelResourceModel> & ExportExcelResourceWithModel